// // src/pages/StaffListPage.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import { Link, useNavigate } from "react-router-dom";
// import { staffApi } from "../Apis/Api";
// import TableDataNoAvailable from "../components/ui/TableDataNoAvailable";
// import LoadingComponent from "../components/ui/LoadingComponent";
// import useDebounce from "../hook/useDebounce";
// import Breadcrumb from "../components/Breadcrumb";
// import { formatDateTime } from "../utils/formatDateTime";
// import PaginationControls from "../components/ui/PaginationControls";
// import { usePermissions } from "../context/PermissionContext";
// import CardContainer from "../components/ui/CardContainer";
// import PerPageDropdown from "../components/ui/PerPageDropdown";
// import ErrorAlert from "../components/ui/ErrorAlert";
// import SortIcons from "../components/ui/SortIcons";
// import StatusBadge from "../components/ui/StatusBadge";
// import { AddButton } from "../components/ui/Button";
// import { handleApiResponse } from "../utils/response";

// const StaffListPage = () => {
//   const navigate = useNavigate();
//   const [staffData, setStaffData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     perPage: 10,
//     total: 0,
//   });
//   const [filters, setFilters] = useState({
//     search: "",
//     status: "",
//   });
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [staffToDelete, setStaffToDelete] = useState(null);
//   const [sortConfig, setSortConfig] = useState({
//     field: null,
//     direction: "asc",
//   });
//   const searchInputRef = useRef(null);
//   const { hasPermission } = usePermissions();

//   useEffect(() => {
//     if (!loading && searchInputRef.current) {
//       searchInputRef.current.focus();
//     }
//   }, [loading]);

//   const debouncedSearch = useDebounce(filters.search, 500);

//   useEffect(() => {
//     fetchStaffData();
//   }, [
//     pagination.currentPage,
//     pagination.perPage,
//     debouncedSearch,
//     filters.status,
//     sortConfig,
//   ]);

//   const fetchStaffData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const fieldMapping = {
//         staff_name: "staff_name",
//         email: "email",
//         phone_no: "phone_no",
//         staff_role: "staff_role",
//         is_active: "is_active",
//         created_by: "created_by",
//         created_datetime: "created_datetime",
//       };

//       const params = {
//         page: pagination.currentPage,
//         per_page: pagination.perPage,
//         search: debouncedSearch,
//         ...(filters.status && {
//           is_active: filters.status === "Active" ? true : false,
//         }),
//         ...(sortConfig.field && {
//           sort_by: fieldMapping[sortConfig.field] || sortConfig.field,
//           sort_order: sortConfig.direction,
//         }),
//       };

//       const response = await staffApi.getStaffByClient(params);
//       handleApiResponse(response, "Fetch Staff", "GET");

//       if (!Array.isArray(response.data)) {
//         throw new Error("Invalid API response: data is not an array");
//       }
//       if (!response.pagination || typeof response.pagination !== "object") {
//         throw new Error("Invalid API response: pagination data missing");
//       }

//       let data = response.data.map((staff, index) => ({
//         id: staff.staff_id || index + 1,
//         staff_name: staff.staff_name || "-",
//         email: staff.email || "-",
//         phone_no: staff.phone_no
//           ? staff.phone_no.replace(/(\d{4})(\d{1,})/, "$1-$2")
//           : "-",
//         staff_role: staff.staff_role || "-",
//         role_id: staff.client_role_id || "",
//         is_active:
//           staff.is_active !== undefined && staff.is_active !== null
//             ? staff.is_active
//               ? "Active"
//               : "Inactive"
//             : "-",
//         created_by: staff.created_by || "-",
//         created_datetime: staff.created_datetime || "-",
//         display_created_datetime: staff.created_datetime
//           ? formatDateTime(staff.created_datetime)
//           : "-",
//       }));

//       if (sortConfig.field) {
//         data = [...data].sort((a, b) => {
//           const valueA = a[sortConfig.field] || "";
//           const valueB = b[sortConfig.field] || "";
//           if (sortConfig.field === "created_datetime") {
//             const dateA = new Date(a.created_datetime || 0);
//             const dateB = new Date(b.created_datetime || 0);
//             return sortConfig.direction === "asc"
//               ? dateA - dateB
//               : dateB - dateA;
//           }
//           return sortConfig.direction === "asc"
//             ? valueA.toString().localeCompare(valueB.toString(), undefined, {
//                 sensitivity: "base",
//               })
//             : valueB.toString().localeCompare(valueA.toString(), undefined, {
//                 sensitivity: "base",
//               });
//         });
//       }

//       setStaffData(data);
//       setPagination((prev) => ({
//         ...prev,
//         currentPage: response.pagination?.current_page || 1,
//         perPage: response.pagination?.per_page || 10,
//         total: response.pagination?.total || data.length,
//       }));
//       setError(null);
//     } catch (err) {
//       const errorMessage =
//         err?.message ||
//         "Failed to fetch staff data. Please check the API endpoint.";
//       setError(errorMessage);
//       setStaffData([]);
//       handleApiResponse(err, "Failed to Fetch Staff", "GET");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePerPageChange = (value) => {
//     setPagination((prev) => ({ ...prev, perPage: value, currentPage: 1 }));
//   };

//   const handlePageChange = (page) => {
//     setPagination((prev) => ({ ...prev, currentPage: page }));
//   };

//   const handleSearchChange = (e) => {
//     setFilters((prev) => ({ ...prev, search: e.target.value }));
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleStatusFilterChange = (status) => {
//     setFilters((prev) => ({
//       ...prev,
//       status: status === "Select Status" ? "" : status,
//     }));
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleEdit = (staff) => {
//     navigate("/staff-edit", { state: { staffData: staff } });
//   };

//   const handleViewDetails = (staff) => {
//     navigate("/staff-details", { state: { staffData: staff } });
//   };

//   const handleAssignBranchLocation = (staff) => {
//     navigate("/staff-branch-assign", {
//       state: {
//         stateData: {
//           staff_id: staff.id.toString(),
//           staff_name: staff.staff_name,
//         },
//         navigationLink: { link: "staff-branches", isLink: true },
//       },
//     });
//   };

//   const handleDeleteClick = (staffId, staffName) => {
//     setStaffToDelete({ id: staffId, name: staffName });
//     setShowDeleteModal(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (staffToDelete) {
//       setLoading(true);
//       try {
//         const response = await staffApi.deleteStaff(staffToDelete?.id);
//         handleApiResponse(
//           response,
//           `Staff "${staffToDelete.name}" deleted successfully`,
//           "DELETE"
//         );

//         setStaffData((prev) =>
//           prev.filter((staff) => staff.id !== staffToDelete.id)
//         );
//         setPagination((prev) => ({
//           ...prev,
//           total: prev.total - 1,
//           currentPage: Math.min(
//             prev.currentPage,
//             Math.ceil((prev.total - 1) / prev.perPage) || 1
//           ),
//         }));
//         setShowDeleteModal(false);
//         setStaffToDelete(null);
//       } catch (err) {
//         const errorMessage = err?.response?.data || "Failed to delete staff";
//         handleApiResponse(
//           err,
//           `Staff "${staffToDelete.name}" deleted Failed`,
//           "DELETE"
//         );
//       } finally {
//         setLoading(false);
//         setShowDeleteModal(false);
//         setStaffToDelete(null);
//       }
//     }
//   };

//   const handleDeleteCancel = () => {
//     setShowDeleteModal(false);
//     setStaffToDelete(null);
//   };

//   const handleSort = (field) => {
//     setSortConfig((prev) => ({
//       field,
//       direction:
//         prev.field === field && prev.direction === "asc" ? "desc" : "asc",
//     }));
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   if (error) {
//     return <ErrorAlert error={error} onRetry={fetchStaffData} />;
//   }

  

//   const headerContent = (
//     <div className="container-fluid">
//       <div className="row align-items-center">
//         <div className="col-12 col-md-6 mb-3 mb-md-0">
//           <div className="d-flex align-items-center flex-wrap gap-3">
//             <div className="navbar-search flex-grow-1">
//               <input
//                 type="text"
//                 className="form-control h-40-px w-100"
//                 name="search"
//                 placeholder="Search by Staff Name, Email, or Role"
//                 value={filters.search}
//                 onChange={handleSearchChange}
//                 ref={searchInputRef}
//                 aria-label="Search staff by name, email, or role"
//               />
//               <i className="bi bi-search icon"></i>
//             </div>
//           </div>
//         </div>
//         <div className="col-12 col-md-6 d-flex align-items-center justify-content-between">
//           <PerPageDropdown
//             perPage={pagination.perPage}
//             handlePerPageChange={handlePerPageChange}
//           />
//           <AddButton
//             label="Add New Staff"
//             permissionKey="add_staff"
//             onClick={() => navigate("/staff-create")}
//           />
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <>
//       <Breadcrumb title="Staff List" />
//       <CardContainer
//         headerContent={headerContent}
//         paginationControls={
//           <PaginationControls
//             pagination={pagination}
//             handlePageChange={handlePageChange}
//           />
//         }
//         loading={loading}
//       >
//         <div
//           className="position-relative"
//           style={{
//             opacity: loading ? 0.4 : 1,
//             pointerEvents: loading ? "none" : "auto",
//           }}
//         >
//           {staffData.length === 0 && !loading ? (
//             <TableDataNoAvailable
//               message={
//                 filters.search || filters.status
//                   ? "No staff match your search or filter."
//                   : "No staff data available."
//               }
//             />
//           ) : (
//             <table className="table bordered-table sm-table mb-0">
//               <thead>
//                 <tr>
//                   <th scope="col">S.No</th>
//                   <th
//                     scope="col"
//                     className="cursor-pointer"
//                     onClick={() => handleSort("staff_name")}
//                     role="button"
//                     aria-label={`Sort by staff name, currently sorted ${
//                       sortConfig.field === "staff_name"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center">
//                       Staff Name
//                       <SortIcons field="staff_name" sortConfig={sortConfig} />
//                     </div>
//                   </th>
//                   <th
//                     scope="col"
//                     className="cursor-pointer"
//                     onClick={() => handleSort("email")}
//                     role="button"
//                     aria-label={`Sort by email, currently sorted ${
//                       sortConfig.field === "email"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center">
//                       Email
//                       <SortIcons field="email" sortConfig={sortConfig} />
//                     </div>
//                   </th>
//                   <th
//                     scope="col"
//                     className="cursor-pointer"
//                     onClick={() => handleSort("phone_no")}
//                     role="button"
//                     aria-label={`Sort by phone number, currently sorted ${
//                       sortConfig.field === "phone_no"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center">
//                       Phone No
//                       <SortIcons field="phone_no" sortConfig={sortConfig} />
//                     </div>
//                   </th>
//                   <th
//                     scope="col"
//                     className="cursor-pointer"
//                     onClick={() => handleSort("staff_role")}
//                     role="button"
//                     aria-label={`Sort by staff role, currently sorted ${
//                       sortConfig.field === "staff_role"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center">
//                       Staff Role
//                       <SortIcons field="staff_role" sortConfig={sortConfig} />
//                     </div>
//                   </th>
//                   <th
//                     scope="col"
//                     className="cursor-pointer"
//                     onClick={() => handleSort("created_by")}
//                     role="button"
//                     aria-label={`Sort by created by, currently sorted ${
//                       sortConfig.field === "created_by"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center">
//                       Created By
//                       <SortIcons field="created_by" sortConfig={sortConfig} />
//                     </div>
//                   </th>
//                   <th
//                     scope="col"
//                     className="text-center cursor-pointer"
//                     onClick={() => handleSort("is_active")}
//                     role="button"
//                     aria-label={`Sort by status, currently sorted ${
//                       sortConfig.field === "is_active"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center justify-content-center">
//                       Status
//                       <SortIcons field="is_active" sortConfig={sortConfig} />
//                     </div>
//                   </th>
//                   <th
//                     scope="col"
//                     className="cursor-pointer"
//                     onClick={() => handleSort("created_datetime")}
//                     role="button"
//                     aria-label={`Sort by created date, currently sorted ${
//                       sortConfig.field === "created_datetime"
//                         ? sortConfig.direction
//                         : "none"
//                     }`}
//                   >
//                     <div className="d-flex align-items-center">
//                       Created Date
//                       <SortIcons
//                         field="created_datetime"
//                         sortConfig={sortConfig}
//                       />
//                     </div>
//                   </th>
//                   <th scope="col" className="text-center">
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {staffData.map((staff, index) => (
//                   <tr key={staff.id}>
//                     <td>
//                       {(pagination.currentPage - 1) * pagination.perPage +
//                         index +
//                         1}
//                     </td>
//                     <td>
//                       <span className="text-md mb-0 fw-normal text-secondary-light">
//                         {staff.staff_name}
//                       </span>
//                     </td>
//                     <td>
//                       <span className="text-md mb-0 fw-normal text-secondary-light">
//                         {staff.email}
//                       </span>
//                     </td>
//                     <td>
//                       <span className="text-md mb-0 fw-normal text-secondary-light">
//                         {staff.phone_no}
//                       </span>
//                     </td>
//                     <td>
//                       <span
//                         className="text-md mb-0 fw-normal text-secondary-light cursor-pointer text-primary-600 hover:text-primary-800"
//                         onClick={() =>
//                           navigate("/staff-roles", {
//                             state: { selectedRole: staff.staff_role },
//                           })
//                         }
//                         role="button"
//                         aria-label={`View roles for ${staff.staff_role}`}
//                       >
//                         {staff.staff_role}
//                       </span>
//                     </td>
//                     <td>
//                       <span className="text-md mb-0 fw-normal text-secondary-light">
//                         {staff.created_by}
//                       </span>
//                     </td>
//                     <td className="text-center">
//                       <StatusBadge status={staff.is_active} />
//                     </td>
//                     <td>
//                       <span className="text-md mb-0 fw-normal text-secondary-light">
//                         {staff.display_created_datetime}
//                       </span>
//                     </td>
//                     <td className="text-center">
//                       <div className="d-flex align-items-center gap-10 justify-content-center">
//                         {hasPermission("assign_staff_branch") && (
//                           <button
//                             type="button"
//                             onClick={() => handleAssignBranchLocation(staff)}
//                             className="bg-primary-50 text-primary-600 bg-hover-primary-100 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
//                             title={`Assign branch & location for ${staff.staff_name}`}
//                             aria-label={`Assign branch & location for ${staff.staff_name}`}
//                           >
//                             <Icon icon="lucide:map-pin" className="menu-icon" />
//                           </button>
//                         )}
//                         {hasPermission("view_staff_details") && (
//                           <button
//                             type="button"
//                             onClick={() => handleViewDetails(staff)}
//                             className="bg-info-focus text-info-600 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
//                             title={`View details for ${staff.staff_name}`}
//                             aria-label={`View details for ${staff.staff_name}`}
//                           >
//                             <Icon icon="heroicons:eye" className="menu-icon" />
//                           </button>
//                         )}
//                         {hasPermission("update_staff") && (
//                           <button
//                             type="button"
//                             onClick={() => handleEdit(staff)}
//                             className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
//                             title={`Edit ${staff.staff_name}`}
//                             aria-label={`Edit staff ${staff.staff_name}`}
//                           >
//                             <Icon icon="lucide:edit" className="menu-icon" />
//                           </button>
//                         )}
//                         {hasPermission("delete_staff") && (
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleDeleteClick(staff.id, staff.staff_name)
//                             }
//                             className="bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
//                             title={`Delete ${staff.staff_name}`}
//                             aria-label={`Delete staff ${staff.staff_name}`}
//                           >
//                             <Icon
//                               icon="fluent:delete-24-regular"
//                               className="menu-icon"
//                             />
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//         {loading  && (
//           <div
//             className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"
//             style={{
//               zIndex: 10,
//               borderRadius: "10px",
//               padding: "20px",
//             }}
//           >
//             <LoadingComponent />
//           </div>
//         )}
//       </CardContainer>
//       <div
//         className={`modal fade ${showDeleteModal ? "show d-block" : ""}`}
//         tabIndex="-1"
//         role="dialog"
//         style={{ display: showDeleteModal ? "block" : "none" }}
//       >
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Confirm Deletion</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={handleDeleteCancel}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <p className="text-neutral-900">
//                 Are you sure you want to delete{" "}
//                 <strong>{staffToDelete?.name || "this staff"}</strong>?
//               </p>
//               <p className="text-neutral-900 small">
//                 This action cannot be undone.
//               </p>
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={handleDeleteCancel}
//                 aria-label="Cancel deletion"
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-danger"
//                 onClick={handleDeleteConfirm}
//                 aria-label={`Confirm delete staff ${staffToDelete?.name || ""}`}
//                 disabled={loading}
//               >
//                 {loading ? "Deleting..." : "Delete"}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       {showDeleteModal && <div className="no-modal fade show"></div>}
//     </>
//   );
// };

// export default StaffListPage;














// src/pages/StaffListPage.jsx
import React, { useState, useEffect, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import { staffApi } from "../Apis/Api";
import TableDataNoAvailable from "../components/ui/TableDataNoAvailable";
import LoadingComponent from "../components/ui/LoadingComponent";
import useDebounce from "../hook/useDebounce";
import Breadcrumb from "../components/Breadcrumb";
import { formatDateTime } from "../utils/formatDateTime";
import PaginationControls from "../components/ui/PaginationControls";
import { usePermissions } from "../context/PermissionContext";
import CardContainer from "../components/ui/CardContainer";
import PerPageDropdown from "../components/ui/PerPageDropdown";
import ErrorAlert from "../components/ui/ErrorAlert";
import SortIcons from "../components/ui/SortIcons";
import StatusBadge from "../components/ui/StatusBadge";
import { AddButton } from "../components/ui/Button";
import { handleApiResponse } from "../utils/response";
import InfoModal from "../components/ui/InfoeModal";

const StaffListPage = () => {
  const navigate = useNavigate();
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    search: "",
    status: "",
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [staffToDelete, setStaffToDelete] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: null,
    direction: "asc",
  });
  const [showInfoModal, setShowInfoModal] = useState(false); // 👈 NEW: Info Modal State
  const searchInputRef = useRef(null);
  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (!loading && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [loading]);

  const debouncedSearch = useDebounce(filters.search, 500);

  useEffect(() => {
    fetchStaffData();
  }, [
    pagination.currentPage,
    pagination.perPage,
    debouncedSearch,
    filters.status,
    sortConfig,
  ]);

  const fetchStaffData = async () => {
    setLoading(true);
    setError(null);
    try {
      const fieldMapping = {
        staff_name: "staff_name",
        email: "email",
        phone_no: "phone_no",
        staff_role: "staff_role",
        is_active: "is_active",
        created_by: "created_by",
        created_datetime: "created_datetime",
      };

      const params = {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        search: debouncedSearch,
        ...(filters.status && {
          is_active: filters.status === "Active" ? true : false,
        }),
        ...(sortConfig.field && {
          sort_by: fieldMapping[sortConfig.field] || sortConfig.field,
          sort_order: sortConfig.direction,
        }),
      };

      const response = await staffApi.getStaffByClient(params);
      handleApiResponse(response, "Fetch Staff", "GET");

      if (!Array.isArray(response.data)) {
        throw new Error("Invalid API response: data is not an array");
      }
      if (!response.pagination || typeof response.pagination !== "object") {
        throw new Error("Invalid API response: pagination data missing");
      }

      let data = response.data.map((staff, index) => ({
        id: staff.staff_id || index + 1,
        staff_name: staff.staff_name || "-",
        email: staff.email || "-",
        phone_no: staff.phone_no
          ? staff.phone_no.replace(/(\d{4})(\d{1,})/, "$1-$2")
          : "-",
        staff_role: staff.staff_role || "-",
        role_id: staff.client_role_id || "",
        is_active:
          staff.is_active !== undefined && staff.is_active !== null
            ? staff.is_active
              ? "Active"
              : "Inactive"
            : "-",
        created_by: staff.created_by || "-",
        created_datetime: staff.created_datetime || "-",
        display_created_datetime: staff.created_datetime
          ? formatDateTime(staff.created_datetime)
          : "-",
      }));

      if (sortConfig.field) {
        data = [...data].sort((a, b) => {
          const valueA = a[sortConfig.field] || "";
          const valueB = b[sortConfig.field] || "";
          if (sortConfig.field === "created_datetime") {
            const dateA = new Date(a.created_datetime || 0);
            const dateB = new Date(b.created_datetime || 0);
            return sortConfig.direction === "asc"
              ? dateA - dateB
              : dateB - dateA;
          }
          return sortConfig.direction === "asc"
            ? valueA.toString().localeCompare(valueB.toString(), undefined, {
                sensitivity: "base",
              })
            : valueB.toString().localeCompare(valueA.toString(), undefined, {
                sensitivity: "base",
              });
        });
      }

      setStaffData(data);
      setPagination((prev) => ({
        ...prev,
        currentPage: response.pagination?.current_page || 1,
        perPage: response.pagination?.per_page || 10,
        total: response.pagination?.total || data.length,
      }));
      setError(null);
    } catch (err) {
      const errorMessage =
        err?.message ||
        "Failed to fetch staff data. Please check the API endpoint.";
      setError(errorMessage);
      setStaffData([]);
      handleApiResponse(err, "Failed to Fetch Staff", "GET");
    } finally {
      setLoading(false);
    }
  };

  const handlePerPageChange = (value) => {
    setPagination((prev) => ({ ...prev, perPage: value, currentPage: 1 }));
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, currentPage: page }));
  };

  const handleSearchChange = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleStatusFilterChange = (status) => {
    setFilters((prev) => ({
      ...prev,
      status: status === "Select Status" ? "" : status,
    }));
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleEdit = (staff) => {
    navigate("/staff-edit", { state: { staffData: staff } });
  };

  const handleViewDetails = (staff) => {
    navigate("/staff-details", { state: { staffData: staff } });
  };

  const handleAssignBranchLocation = (staff) => {
    navigate("/staff-branch-assign", {
      state: {
        stateData: {
          staff_id: staff.id.toString(),
          staff_name: staff.staff_name,
        },
        navigationLink: { link: "staff-branches", isLink: true },
      },
    });
  };

  const handleDeleteClick = (staffId, staffName) => {
    setStaffToDelete({ id: staffId, name: staffName });
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (staffToDelete) {
      setLoading(true);
      try {
        const response = await staffApi.deleteStaff(staffToDelete?.id);
        handleApiResponse(
          response,
          `Staff "${staffToDelete.name}" deleted successfully`,
          "DELETE"
        );

        setStaffData((prev) =>
          prev.filter((staff) => staff.id !== staffToDelete.id)
        );
        setPagination((prev) => ({
          ...prev,
          total: prev.total - 1,
          currentPage: Math.min(
            prev.currentPage,
            Math.ceil((prev.total - 1) / prev.perPage) || 1
          ),
        }));
        setShowDeleteModal(false);
        setStaffToDelete(null);
      } catch (err) {
        const errorMessage = err?.response?.data || "Failed to delete staff";
        handleApiResponse(
          err,
          `Staff "${staffToDelete.name}" deleted Failed`,
          "DELETE"
        );
      } finally {
        setLoading(false);
        setShowDeleteModal(false);
        setStaffToDelete(null);
      }
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setStaffToDelete(null);
  };

  const handleSort = (field) => {
    setSortConfig((prev) => ({
      field,
      direction:
        prev.field === field && prev.direction === "asc" ? "desc" : "asc",
    }));
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  // 👈 NEW: Info Modal Handlers
  const handleInfoClick = () => {
    setShowInfoModal(true);
  };

  const handleInfoClose = () => {
    setShowInfoModal(false);
  };

  if (error) {
    return <ErrorAlert error={error} onRetry={fetchStaffData} />;
  }

  const headerContent = (
    <div className="container-fluid">
      <div className="row align-items-center">
        <div className="col-12 col-md-6 mb-3 mb-md-0">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <div className="navbar-search flex-grow-1">
              <input
                type="text"
                className="form-control h-40-px w-100"
                name="search"
                placeholder="Search by Staff Name or Email"
                value={filters.search}
                onChange={handleSearchChange}
                ref={searchInputRef}
                aria-label="Search staff by name, email, or role"
              />
              <i className="bi bi-search icon"></i>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex align-items-center justify-content-between">
          <PerPageDropdown
            perPage={pagination.perPage}
            handlePerPageChange={handlePerPageChange}
          />
          <div className="d-flex align-items-center gap-2"> {/* 👈 UPDATED: Added Info Button */}
            <button
              type="button"
              className="bg-info-50 text-info-600 bg-hover-info-100 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Information about the Staff List Page"
              onClick={handleInfoClick}
              aria-label="Page Information"
            >
              <Icon icon="lucide:info" className="menu-icon" />
            </button>
            <AddButton
              label="Add New Staff"
              permissionKey="add_staff"
              onClick={() => navigate("/staff-create")}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Breadcrumb title="Staff List" />
      <CardContainer
        headerContent={headerContent}
        paginationControls={
          <PaginationControls
            pagination={pagination}
            handlePageChange={handlePageChange}
          />
        }
        loading={loading}
      >
        <div
          className="position-relative"
          style={{
            opacity: loading ? 0.4 : 1,
            pointerEvents: loading ? "none" : "auto",
          }}
        >
          {staffData.length === 0 && !loading ? (
            <TableDataNoAvailable
              message={
                filters.search || filters.status
                  ? "No staff match your search or filter."
                  : "No staff data available."
              }
            />
          ) : (
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">S.No</th>
                  <th
                    scope="col"
                    className="cursor-pointer"
                    onClick={() => handleSort("staff_name")}
                    role="button"
                    aria-label={`Sort by staff name, currently sorted ${
                      sortConfig.field === "staff_name"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      Staff Name
                      <SortIcons field="staff_name" sortConfig={sortConfig} />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="cursor-pointer"
                    onClick={() => handleSort("email")}
                    role="button"
                    aria-label={`Sort by email, currently sorted ${
                      sortConfig.field === "email"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      Email
                      <SortIcons field="email" sortConfig={sortConfig} />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="cursor-pointer"
                    onClick={() => handleSort("phone_no")}
                    role="button"
                    aria-label={`Sort by phone number, currently sorted ${
                      sortConfig.field === "phone_no"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      Phone No
                      <SortIcons field="phone_no" sortConfig={sortConfig} />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="cursor-pointer"
                    onClick={() => handleSort("staff_role")}
                    role="button"
                    aria-label={`Sort by staff role, currently sorted ${
                      sortConfig.field === "staff_role"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      Staff Role
                      <SortIcons field="staff_role" sortConfig={sortConfig} />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="cursor-pointer"
                    onClick={() => handleSort("created_by")}
                    role="button"
                    aria-label={`Sort by created by, currently sorted ${
                      sortConfig.field === "created_by"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      Created By
                      <SortIcons field="created_by" sortConfig={sortConfig} />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="text-center cursor-pointer"
                    onClick={() => handleSort("is_active")}
                    role="button"
                    aria-label={`Sort by status, currently sorted ${
                      sortConfig.field === "is_active"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center justify-content-center">
                      Status
                      <SortIcons field="is_active" sortConfig={sortConfig} />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="cursor-pointer"
                    onClick={() => handleSort("created_datetime")}
                    role="button"
                    aria-label={`Sort by created date, currently sorted ${
                      sortConfig.field === "created_datetime"
                        ? sortConfig.direction
                        : "none"
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      Created Date
                      <SortIcons
                        field="created_datetime"
                        sortConfig={sortConfig}
                      />
                    </div>
                  </th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {staffData.map((staff, index) => (
                  <tr key={staff.id}>
                    <td>
                      {(pagination.currentPage - 1) * pagination.perPage +
                        index +
                        1}
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {staff.staff_name}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {staff.email}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {staff.phone_no}
                      </span>
                    </td>
                    <td>
                      <span
                        className="text-md mb-0 fw-normal text-secondary-light cursor-pointer text-primary-600 hover:text-primary-800"
                        onClick={() =>
                          navigate("/staff-roles", {
                            state: { selectedRole: staff.staff_role },
                          })
                        }
                        role="button"
                        aria-label={`View roles for ${staff.staff_role}`}
                      >
                        {staff.staff_role}
                      </span>
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {staff.created_by}
                      </span>
                    </td>
                    <td className="">
                      <StatusBadge status={staff.is_active} />
                    </td>
                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {staff.display_created_datetime}
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        {hasPermission("assign_staff_branch") && (
                          <button
                            type="button"
                            onClick={() => handleAssignBranchLocation(staff)}
                            className="bg-primary-50 text-primary-600 bg-hover-primary-100 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            title={`Assign branch & location for ${staff.staff_name}`}
                            aria-label={`Assign branch & location for ${staff.staff_name}`}
                          >
                            <Icon icon="lucide:map-pin" className="menu-icon" />
                          </button>
                        )}
                        {hasPermission("view_staff_details") && (
                          <button
                            type="button"
                            onClick={() => handleViewDetails(staff)}
                            className="bg-info-focus text-info-600 bg-hover-info-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            title={`View details for ${staff.staff_name}`}
                            aria-label={`View details for ${staff.staff_name}`}
                          >
                            <Icon icon="heroicons:eye" className="menu-icon" />
                          </button>
                        )}
                        {hasPermission("update_staff") && (
                          <button
                            type="button"
                            onClick={() => handleEdit(staff)}
                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            title={`Edit ${staff.staff_name}`}
                            aria-label={`Edit staff ${staff.staff_name}`}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </button>
                        )}
                        {hasPermission("delete_staff") && (
                          <button
                            type="button"
                            onClick={() =>
                              handleDeleteClick(staff.id, staff.staff_name)
                            }
                            className="bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            title={`Delete ${staff.staff_name}`}
                            aria-label={`Delete staff ${staff.staff_name}`}
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="menu-icon"
                            />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {loading && (
          <div
            className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"
            style={{
              zIndex: 10,
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <LoadingComponent />
          </div>
        )}
      </CardContainer>

      {/* 👈 EXISTING: Delete Modal */}
      <div
        className={`modal fade ${showDeleteModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: showDeleteModal ? "block" : "none",backgroundColor: showDeleteModal ? "rgba(0,0,0,0.5)" : "" 
 }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleDeleteCancel}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p className="text-neutral-900">
                Are you sure you want to delete{" "}
                <strong>{staffToDelete?.name || "this staff"}</strong>?
              </p>
              <p className="text-neutral-900 small">
                This action cannot be undone.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDeleteCancel}
                aria-label="Cancel deletion"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDeleteConfirm}
                aria-label={`Confirm delete staff ${staffToDelete?.name || ""}`}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && <div className="no-modal fade show"></div>}

      {/* 👈 NEW: Info Modal - EXACTLY SAME AS ClientRolesPage */}
    <InfoModal
  isOpen={showInfoModal}
  onClose={handleInfoClose}
  title="Staff Management - Complete Overview"
>
  <p className="text-neutral-900 mb-4">
    This is the <strong>central hub</strong> for managing all staff members across your organization. 
    Admins can add, view, edit, assign roles & locations, and control access for every team member.
  </p>

  <h6 className="fw-bold text-primary-600 mb-3">Core Features</h6>
  <ul className="list-group list-group-flush mb-4">
    <li className="list-group-item">View complete staff list with Name, Email, Phone & Role</li>
    <li className="list-group-item">Add new staff with full control over credentials and role assignment</li>
    <li className="list-group-item">Edit or delete staff (delete only if not linked to active records)</li>
    <li className="list-group-item">Assign staff to specific <strong>Branches → Locations</strong> with designated roles</li>
    <li className="list-group-item">Quick view of staff details including contact info and current assignments</li>
  </ul>

  <h6 className="fw-bold text-primary-600 mb-3">Add New Staff – Required Fields</h6>
  <p className="small text-neutral-600 mb-2">Clicking "Add Staff" opens a form with the following fields:</p>
  <ul className="list-group list-group-flush mb-4">
    <li className="list-group-item"><strong>Full Name</strong> – Display name of the employee</li>
    <li className="list-group-item"><strong>Email</strong> – Login email (must be unique)</li>
    <li className="list-group-item"><strong>Phone Number</strong> – Contact number (with country code)</li>
    <li className="list-group-item"><strong>Role</strong> – Select from available roles (e.g., Manager, Cashier, Supervisor)</li>
    <li className="list-group-item"><strong>Password</strong> – Secure initial password (user can change later)</li>
  </ul>

  <h6 className="fw-bold text-primary-600 mb-3">Action Buttons (Per Staff Row)</h6>
  <ul className="list-group list-group-flush mb-4">
    <li className="list-group-item">
      <strong>View (Eye Icon)</strong><br/>
      Shows detailed profile:<br/>
      → Full contact info (Email + Phone)<br/>
      → Current Role & Position<br/>
      → Assigned Branches/Locations<br/>
      → Account status & join date
    </li>
    <li className="list-group-item">
      <strong>Assign (Location/Person Icon)</strong><br/>
      <span className="text-success-600 fw-bold">Most Important Action</span><br/>
      Opens assignment panel:<br/>
      → Select <strong>Branch</strong> → Choose <strong>Location</strong> → Assign this staff with selected Role<br/>
      <small className="">Creates active linkage – required for login & operations</small>
    </li>
    <li className="list-group-item">
      <strong>Edit (Green Pencil)</strong><br/>
      Update name, contact, role, or reset password
    </li>
    <li className="list-group-item">
      <strong>Delete (Red Trash)</strong><br/>
      Permanently remove staff<br/>
      <small className="text-danger">Blocked if staff has transactions or active assignments</small>
    </li>
  </ul>

  <div className="alert alert-info small mt-4">
    <strong>Important Notes:</strong><br/>
    • New staff <strong>cannot log in</strong> until assigned to at least one Branch + Location<br/>
    • Role selected during "Add Staff" is default – final role applies per assignment<br/>
    • Staff with temporary IDs ("temp_") may show disabled actions → refresh page<br/>
    • Always <strong>Add → Assign Immediately</strong> for instant activation
  </div>

  <p className="text-neutral-900 mt-4 fw-bold text-primary">
    Pro Tip: Best Practice → Add Staff → Click Assign Icon → Select Branch & Location → Done! User can log in instantly.
  </p>
  <p className="text-neutral-900 small">
    Business Impact: Properly assigned staff = smooth operations, accurate reporting, and full system access control.
  </p>
</InfoModal>
    </>
  );
};

export default StaffListPage;